import { Button, Div, Text } from "atomize"
import { theme } from "../settings/config"
import { SchemaThumbnail } from "../lesson/schema/ExerciseSchema"
import { notebookUpdateLabel } from "../utils/notebook.utils"

// Sotto un esercizio preso dal quaderno, quando nel quaderno è andato avanti
// (`notebookUpdate`): cosa è cambiato, lo schema di adesso in piccolo, e
// **Aggiorna**, che riprende testo e schema nella riga. La lezione cambia
// solo quando si salva il foglio: Annulla la lascia com'era.
//
// Sul fondo caldo del foglio, il riquadro è della superficie, come i campi;
// il suo bordo sinistro cade su quello del testo dell'esercizio, come la
// miniatura dello schema.
function NotebookUpdate({ update, name, disabled, onUpdate }) {
	const { entry, textChanged, changedHere } = update
	const hint = changedHere
		? "Prende il posto di quello che hai cambiato qui"
		: textChanged
			? `«${entry.text}»`
			: "Il testo è lo stesso"
	return (
		<Div
			m={{ l: "1.125rem" }}
			p={{ l: entry.schema ? "0.5rem" : "0.75rem", r: "0.25rem", y: "0.5rem" }}
			bg={theme.colors.surface}
			rounded="15px"
			d="flex"
			align="center"
			style={{ gap: "0.625rem" }}>
			{entry.schema && <SchemaThumbnail schema={entry.schema} width="2.75rem" height="3rem" />}
			<Div flexGrow="1" style={{ minWidth: 0 }}>
				<Text textSize="caption" textWeight="600" textColor={theme.colors.gunmetal}>
					{notebookUpdateLabel(update)}
				</Text>
				<Text
					textSize="tiny"
					textColor={theme.colors.text_light}
					style={{
						display: "-webkit-box",
						WebkitLineClamp: 2,
						WebkitBoxOrient: "vertical",
						overflow: "hidden",
					}}>
					{hint}
				</Text>
			</Div>
			<Button
				h="2.25rem"
				p={{ x: "0.5rem" }}
				bg="transparent"
				textColor={theme.colors.primary}
				textWeight="600"
				disableBg="transparent"
				disableColor={theme.colors.text_light}
				style={{ flex: "none" }}
				aria-label={`Aggiorna dal quaderno: ${name}`}
				disabled={disabled}
				onClick={onUpdate}>
				Aggiorna
			</Button>
		</Div>
	)
}

export default NotebookUpdate
